// GrapeJS Link Box Plugin

import { blockCategories } from '../../categories';

export default (editor, opts = {}) => {
    const options = {
        linkBoxCategory: blockCategories.basic,
        linkBoxLabel: 'Link-Box',
        ...opts,
    };

    const domc = editor.DomComponents;

    const linkBoxType = {
        isComponent: (el) =>
            el.tagName === 'A' && el.classList.contains('link-box'),
        model: {
            defaults: {
                tagName: 'a',
                droppable: true,
                attributes: { href: '#', class: 'link-box' },
                traits: [
                    {
                        type: 'checkbox',
                        name: 'target',
                        label: 'Open in new tab',
                        changeProp: 1,
                    },
                    {
                        type: 'text',
                        name: 'href',
                        label: 'URL',
                        placeholder: '#',
                        changeProp: 1,
                    },
                ],
                style: {
                    display: 'inline-block',
                    'max-width': '100%',
                    padding: '12px',
                },
            },

            init() {
                this.on('change:target', this.handleTarget);
                this.on('change:href', this.handleHref);
            },

            handleTarget() {
                const target = this.get('target');
                if (target) {
                    this.set('attributes', {
                        ...this.get('attributes'),
                        target: '_blank',
                    });
                } else {
                    const attrs = { ...this.get('attributes') };
                    delete attrs.target;
                    this.set('attributes', attrs);
                }
            },

            handleHref() {
                this.set('attributes', {
                    ...this.get('attributes'),
                    href: this.get('href'),
                });
            },
        },
    };

    domc.addType('link-box', linkBoxType);

    const linkBoxBlock = {
        label: options.linkBoxLabel,
        category: options.linkBoxCategory,
        content: {
            type: 'link-box',
            style: {
                'text-decoration': 'none',
            },
        },
        media: `<svg viewBox="0 0 24 24">
          <path d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M11,16H10C8.39,16 6,14.94 6,12C6,9.07 8.39,8 10,8H11V10H10C9.54,10 8,10.17 8,12C8,13.9 9.67,14 10,14H11V16M14,16H13V14H14C14.46,14 16,13.83 16,12C16,10.1 14.33,10 14,10H13V8H14C15.61,8 18,9.07 18,12C18,14.94 15.61,16 14,16M15,13H9V11H15V13Z"></path>
        </svg>`,
    };

    // Add block
    editor.BlockManager.add('link-box', linkBoxBlock);

    // Return any public API if needed
    return {};
};
